import React, {useEffect, useMemo, useState} from 'react';
import {useUserContext} from 'authentication/UserContext';
import {
	useAggregateRequirementMutation,
	useAggregateRequirementsMutation,
} from '../hooks/requirementAggregate.generated';
import {useTranslation} from 'react-i18next';
import {ConfirmAggregateDialog} from 'components/Dialogs/ConfirmAggregateDialog/ConfirmAggregateDialog';

export const AggregateRequirementsButton: React.FC = () => {
	const {t} = useTranslation('features/requirements', {
		keyPrefix: 'AggregateRequirementsDialog',
	});
	const [aggregateRequirements] = useAggregateRequirementsMutation();

	const {isAdmin} = useUserContext();

	const handleConfirm = () => {
		aggregateRequirements();
	};

	return (
		<ConfirmAggregateDialog
			buttonKey='aggregateRequirements'
			buttonText={t('AggregateRequirements')}
			buttonHidden={!isAdmin}
			handleConfirm={handleConfirm}
			dialogText={t('AggregateRequirementsText')}
			dialogTitle={t('AggregateRequirementsTitle')}
		/>
	);
};

export const AggregateRequirementButton: React.FC<{reqId: string}> = ({
	reqId,
}) => {
	const {t} = useTranslation('features/requirements', {
		keyPrefix: 'AggregateRequirementsDialog',
	});
	const [aggregateRequirement] = useAggregateRequirementMutation();

	const {isAdmin} = useUserContext();

	const handleConfirm = () => {
		aggregateRequirement();
	};

	return (
		<ConfirmAggregateDialog
			buttonKey='aggregateRequirements'
			buttonText={t('AggregateRequirements')}
			buttonHidden={!isAdmin}
			handleConfirm={handleConfirm}
			dialogText={t('AggregateRequirementsTitle')}
			dialogTitle={t('AggregateRequirementsText')}
		/>
	);
};
